export const avatarDefault = {
  sex: 'man',
  faceColor: '#c1977b',
  earSize: 'small',
  hairColor: '#050505',
  hairStyle: 'normal',
  hairColorRandom: false,
  hatColor: '#1e1682',
  hatStyle: 'none',
  eyeStyle: 'circle',
  glassesStyle: 'none',
  noseStyle: 'long',
  mouthStyle: 'smile',
  shirtStyle: 'polo',
  shirtColor: '#000000',
  bgColor: '#ffffff',
  isGradient: false,
};
